import { round } from 'lodash';
import { TimeLineData } from '@ardoq/api-types';
import { format, getYear, parseDate } from '@ardoq/date-time';
import { Locale } from '@ardoq/locale';

const formatDateForChart = (
  dateString: string,
  isMultiYear: boolean,
  locale: Locale
): string => {
  const date = parseDate(dateString);
  return format(date, isMultiYear ? 'MMM d, yyyy' : 'MMM d', { locale });
};

const isMultiYearData = (data: TimeLineData): boolean => {
  const years = new Set(
    data.flatMap(({ values }) =>
      values.map(({ _time }) => getYear(parseDate(_time)))
    )
  );
  return years.size > 1;
};

export const getDataValuesAsArray = (data: TimeLineData, locale: Locale) => {
  const isMultiYear = isMultiYearData(data);
  return data.map(({ total, values, ...rest }) => ({
    ...rest,
    total: total ? round(total, 2) : total,
    values: values.map(({ value, _time }) => [
      formatDateForChart(_time, isMultiYear, locale),
      value ? round(value, 2) : value,
    ]),
  }));
};

export const getDataWithTotal = (data: TimeLineData) =>
  data.map(element => ({
    ...element,
    total: element.values.reduce<number>(
      (acc, current) => acc + (current.value ?? 0),
      0
    ),
  }));
